import Profile from '../pages/Profile'
import Admin from '../pages/Admin'
import LoginWithUsername from '../pages/LoginWithUsername'
import Statistics from '../pages/Statistics'
import CommingSoon from '../pages/CommingSoon'
import Trading from '../pages/Trading'


const routes = [

    { path: "/profile", name: "Log in", icon: "", component: Profile, public: true, settings: { hideTabBar: true, hideHeader: false }, protected: true },
    { path: "/login", name: "Log in", icon: "", component: LoginWithUsername, public: true, protected: false, settings: { hideTabBar: true, hideHeader: true } },
    { path: "/statistics/:page?", name: "Log in", icon: "", component: Statistics, public: true, protected: false, settings: { hideTabBar: true, hideHeader: true } },

    { path: "/trading/:page?", name: "Log in", icon: "", component: Trading, public: true, protected: false, settings: { hideTabBar: true, hideHeader: true } },
    { path: "/services/:page?", name: "Log in", icon: "", component: CommingSoon, public: true, protected: false, settings: { hideTabBar: true, hideHeader: true } },
    { path: "/insurance/:page?", name: "Log in", icon: "", component: CommingSoon, public: true, protected: false, settings: { hideTabBar: true, hideHeader: true } },

    { path: "/:page?", name: "add wiki", icon: "", component: Admin, public: true, protected: true },


    // { path: "/", name: "Home", icon: "", component: Home, public: true, exact: true, settings: { hideTabBar: false, hideHeader: true }, protected: true },
    // { path: "/applet/:id", name: "applet", icon: "", component: Applet, public: true, protected: true },

    // { path: "/forgotpassword", name: "forgotPassword", icon: "", component: Login, public: true, protected: false },
    // { path: "/manage", name: "manage", icon: "", component: Manage, public: true, protected: true },


    // { path: "/things", name: "things", icon: "", component: Things, public: true, protected: true },

    // { path: "/thing/:id", name: "thing", icon: "", component: ThingSingle, public: true, protected: true },

    // { path: "/rigram/:id", name: "rigram", icon: "", component: Rigram, public: true, protected: true },

    // { path: "/explore", name: "explore", icon: "", component: Explore, public: true, protected: true },
    // { path: "/service/:id", name: "service", icon: "", component: Service, public: true, protected: true },

    // { path: "/addThing", name: "add thing", icon: "", component: AddThing, public: true, protected: true },
    // { path: "/addWiki", name: "add wiki", icon: "", component: AddWiki, public: true, protected: true },
    // { path: "/addApplet", name: "add applet", icon: "", component: AddApplet, public: true, protected: true },


    // { path: "/editor", name: "editor", icon: "", component: Editor, public: true, protected: true },
    // { path: "/shop", name: "shop", icon: "", component: Explore, public: true, protected: true },


    // { path: "/editDashboard/:id?", name: "editDashboard", icon: "", component: DashboardEditor, public: true, protected: true },
    // { path: "/dashboard/:id", name: "editDashboard", icon: "", component: Dashboard, public: true, protected: true },



    /// YONNECT
    // { path: "/", name: "Home", icon: "", component: Tower, public: true, exact: true, settings: { hideTabBar: false, hideHeader: true }, protected: true },
    // { path: "/applet", name: "New Applet", icon: "", component: YonnectApplet, public: true, exact: false, settings: { hideTabBar: false, hideHeader: true }, protected: true },

    // { path: "/new/applet", name: "New Applet", icon: "", component: NewApplet, public: true, exact: true, settings: { hideTabBar: false, hideHeader: true }, protected: true },

    // { path: "/new/business", name: "New Business", icon: "", component: NewProfile, public: true, exact: true, settings: { hideTabBar: false, hideHeader: true }, protected: true },


    // { path: "/formbuilder", name: "Form builder", icon: "", component: FormBuilder, public: true, exact: false, settings: { hideTabBar: false, hideHeader: true }, protected: true },
    // { path: "/pagebuilder", name: "Page builder", icon: "", component: PageBuilder, public: true, exact: false, settings: { hideTabBar: false, hideHeader: true }, protected: true },

    // { path: "/a/:urlcode", name: "New Applet", icon: "", component: YonnectApplet, public: true, exact: false, settings: { hideTabBar: false, hideHeader: true }, protected: true },

    // { path: "/p", name: "New Applet", icon: "", component: SearchUser, public: true, exact: false, settings: { hideTabBar: false, hideHeader: true }, protected: true },

    // { path: "*", name: "New Applet", icon: "", component: SearchUser, public: true, exact: false, settings: { hideTabBar: false, hideHeader: true }, protected: true },

]


export default routes